import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { ApiRfrMethod } from 'src/app/api/api-methods.rfr';
import { RfrCplLocationsI } from 'src/app/api/rfr-cpl-locations/rfr-cpl-locations.result.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { spxToasterActions } from '@softpak/components/spx-toaster';
import { RfrCplLocationsActions } from './rfr-cpl-locations.actions';

@Injectable()
export class RfrCplLocationsEffects {
  private readonly actions$ = inject(Actions);
  private readonly sharedGenericService = inject(SharedGenericService);

  load$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(RfrCplLocationsActions.load),
    mergeMap(action => from(this.sharedGenericService.invoke(ApiRfrMethod.rfrCplLocations, action.query))
      .pipe(
        map((result: RfrCplLocationsI) => RfrCplLocationsActions.received({
          result,
        })),
        catchError((error: SharedErrorObjectI) => {
          console.error(error);
          return [
            RfrCplLocationsActions.error({
              error: error.message,
            }),
            spxToasterActions.createError({
              autoClose: error.autoclose ? 5000 : undefined,
              messageText: `${error?.title ? `${error.title}: ` : ''}${error.message}`,
            }),
          ];
        }),
      )),
  ));
}
